import classNames from 'classnames';
import { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';

import PageForm from 'components/forms/PageForm';
import LoadingSpinner from 'components/icons/LoadingSpinner';
import { ModalDialogLink } from 'components/modal/Modal';
import { IPage } from 'features/page/pageAPI';
import { useSite } from 'selectors/siteSelectors';
import { useUser } from 'selectors/userSelectors';
import PageView from './PageView';

import { useUsers } from 'selectors/usersSelectors';
import './Pages.scss';

export default function Pages() {
  const { userIsAdmin } = useUser();
  const { pages } = useSite();
  const { users } = useUsers();

  const sortedPages = useMemo(() => {
    if (!pages) return [];
    return [...pages].sort((a, b) => {
      const slugCompare = (a.slug ?? '').localeCompare(b.slug ?? '');
      if (slugCompare !== 0) return slugCompare;
      return (a.locale ?? '').localeCompare(b.locale ?? '');
    });
  }, [pages]);

  return !pages ? (
    <LoadingSpinner active={true}>
      <FormattedMessage id="NAVIGATION.LOADER.PAGES" />
    </LoadingSpinner>
  ) : (
    <div className={classNames('menus_container')}>
      <div className={classNames('menus')}>
        {sortedPages?.length ? (
          sortedPages.map((page: IPage, index: number) => (
            <PageView page={page} key={index} />
          ))
        ) : (
          <div className="no_menus">
            <FormattedMessage id={'PAGES.NONE'} />
          </div>
        )}
        {userIsAdmin ? (
          <>
            <ModalDialogLink className="nav_item" component={PageForm}>
              <FormattedMessage id={'PAGES.NEW_PAGE'} />
            </ModalDialogLink>
          </>
        ) : null}
      </div>
    </div>
  );
}
